<template>

    <div class="mainContainer position-relative d-flex justify-content-center align-items-center">

        <!-- Logo -->
        <div class="logo">
            <RouterLink to="/">
                <img src="../../../../dist/assets/GITSlogo.png" href="#"
                    style="width: auto; height: 80px; border-radius: 15px;">
            </RouterLink>
        </div>

        <div class="row d-flex justify-content-center align-items-center">
            <!-- Login Modal -->
            <div v-if="currentModal === 'login'" class="col-10 col-md-8 col-lg-6 loginModal mx-auto d-flex flex-column"
                ref="modalContainer">
                <div class="d-flex justify-content-between">
                    <router-link to="/" class="text-start">
                        <i class="fa-solid fa-house" style="margin-left: 8px; margin-top: 8px; font-size: 24px;"></i>
                    </router-link>

                    <div class="language-switcher me-2">
                        <button class="lang-btn" :class="{ active: $GetLocalization() === 'en' }"
                            @click="$SetLocalization('en')">
                            {{ $Translate('english') }}
                        </button>
                        <button class="lang-btn" :class="{ active: $GetLocalization() === 'ar' }"
                            @click="$SetLocalization('ar')">
                            {{ $Translate('arabic') }}
                        </button>
                    </div>
                </div>

                <div class="text-center">
                    <h2 class="mt-3 mb-3"><strong>{{ $Translate('login') }}</strong></h2>
                    <p>{{ $Translate('loginSubTitle') }}</p>
                </div>

                <div class="p-3">
                    <form id="LoginForm" method="post">
                        <div class="row p-3">
                            <div class="form-group position-relative mb-3">
                                <label class="mb-2" for="LoginEmail">
                                    <strong>{{ $Translate('yourEmail') }}:</strong>
                                    <span class="text-danger">*</span>
                                </label>
                                <input type="email" id="LoginEmail" class="form-control custom-radius" :class="{
                                    'is-valid': loginSubmitted && loginEmailIsValid,
                                    'is-invalid': loginSubmitted && !loginEmailIsValid,
                                }" v-model="applicant.userId" :placeholder="$Translate('enterEmail')" name="userId" />
                            </div>

                            <div class="form-group position-relative">
                                <label class="mb-2" for="LoginPassword">
                                    <strong>{{ $Translate('password') }}:</strong>
                                    <span class="text-danger">*</span>
                                </label>
                                <input :type="[passwordReveal ? 'text' : 'password']" id="LoginPassword" name="password"
                                    class="form-control custom-radius" :class="{
                                        'is-valid': loginSubmitted && loginPassIsValid,
                                        'is-invalid': loginSubmitted && !loginPassIsValid,
                                    }" v-model="applicant.password" :placeholder="$Translate('enterPassword')" />
                                <span @click="passwordReveal = !passwordReveal" :dir="isRtl ? 'rtl' : 'ltr'">
                                    <span class="fa-solid fa-fw border-2 eye-icon" :class="[
                                        passwordReveal ? 'fa-eye' : 'fa-eye-slash',
                                        isRtl ? 'rtl-eye-icon' : '',
                                    ]"></span>
                                </span>
                            </div>

                            <div class="d-flex justify-content-between align-items-center mt-1">
                                <div class="form-check" style="font-size: 16px;">
                                    <input type="checkbox" class="form-check-input me-2" id="customCheck1" />
                                    <label class="form-check-label font-weight-bold" for="customCheck1">
                                        {{ $Translate('rememberMe') }}
                                    </label>
                                </div>
                                <a href="#" @click.prevent="showModal('forget', 'next')" class="text-decoration-none"
                                    style="font-size: 16px;">
                                    <u>{{ $Translate('forgotPassword') }}</u>
                                </a>
                            </div>

                            <div class="mt-4 d-flex justify-content-center">
                                <button type="button" class="btn w-100 custom-radius text-white"
                                    style="background: #00013A;" @click.prevent="signIn()">
                                    {{ $Translate('login') }}
                                </button>
                            </div>

                            <div class="mt-5 d-flex justify-content-center align-items-center"
                                style="margin-bottom: -10px;">
                                <p>
                                    <small class="text-dark me-2">{{ $Translate('dontHaveAccount') }}</small>
                                    <RouterLink to="/Registration"><a class="text-dark font-weight-bold"><strong>{{
                                        $Translate('signUp') }}</strong></a></RouterLink>
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Forget Modal -->
            <div v-else-if="currentModal === 'forget'" class="col-10 forgetModal mx-auto" ref="modalContainer">
                <a class="text-start" @click.prevent="showModal('login', 'prev')">
                    <i :class="['fa-solid', isRtl ? 'fa-angles-right' : 'fa-angles-left']"
                        style="margin-left: 8px; margin-top: 8px; font-size: 24px; cursor: pointer;"></i>
                </a>

                <div class="text-center">
                    <h2 class="mt-3 mb-3"><strong>{{ $Translate('recoverAccount') }}</strong></h2>
                    <p>{{ $Translate('forgetSubTitle') }}</p>
                </div>

                <div class="p-3">
                    <form id="ForgetPasswordForm" method="post">
                        <input type="hidden" name="companyId" value="usmf" />
                        <div class="form-group position-relative mb-3">
                            <label class="mb-2 me-1">
                                <strong>{{ $Translate('emailAddress') }}:</strong><span class="text-danger">*</span>
                            </label>
                            <input id="ForgetPasswordEmail" type="email" class="form-control custom-radius" :class="{
                                'is-valid': forgetSubmitted && forgetEmailIsValid,
                                'is-invalid': forgetSubmitted && !forgetEmailIsValid,
                            }" v-model="forgotEmail" :placeholder="$Translate('enterYourEmailAddress')" name="email" />
                        </div>
                        <div class="mt-4 d-flex justify-content-center">
                            <button type="button" class="btn w-100 custom-radius text-white"
                                style="background: #00013A;" @click.prevent="forgot()">
                                {{ $Translate('send') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Reset Modal -->
            <div v-else-if="currentModal === 'reset'" class="col-10 resetModal mx-auto" ref="modalContainer">
                <a class="text-start" @click.prevent="showModal('forget', 'prev')">
                    <i :class="['fa-solid', isRtl ? 'fa-angles-right' : 'fa-angles-left']"
                        style="margin-left: 8px; margin-top: 8px; font-size: 24px; cursor: pointer;"></i>
                </a>

                <div class="text-center">
                    <h2 class="mt-3 mb-3"><strong>{{ $Translate('resetPassword') }}</strong></h2>
                    <p>{{ $Translate('resetSubTitle') }}</p>
                </div>

                <div class="p-3">
                    <form id="ResetPasswordForm">
                        <div class="form-group position-relative mb-3">
                            <label class="mb-2 me-1">
                                <strong>{{ $Translate('otp') }}:</strong> <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control custom-radius" :class="{
                                'is-valid': resetSubmitted && resetTokenIsValid,
                                'is-invalid': resetSubmitted && !resetTokenIsValid,
                            }" name="token" v-model="resetToken" :placeholder="$Translate('otpPlaceholder')" />
                        </div>

                        <div class="form-group position-relative mb-3">
                            <label class="mb-2 me-1">
                                <strong>{{ $Translate('newPassword') }}:</strong> <span class="text-danger">*</span>
                            </label>
                            <input type="password" class="form-control custom-radius" :class="{
                                'is-valid': resetSubmitted && resetNewPasswordIsValid,
                                'is-invalid': resetSubmitted && !resetNewPasswordIsValid,
                            }" name="newPassword" v-model="newPassword" :placeholder="$Translate('password')" />
                        </div>

                        <div class="form-group position-relative mb-3">
                            <label class="mb-2 me-1">
                                <strong>{{ $Translate('confirmNewPassword') }}:</strong> <span
                                    class="text-danger">*</span>
                            </label>
                            <input type="password" class="form-control custom-radius" :class="{
                                'is-valid': resetSubmitted && resetConfirmNewPasswordIsValid,
                                'is-invalid': resetSubmitted && !resetConfirmNewPasswordIsValid,
                            }" name="confirmNewPassword" v-model="confirmNewPassword"
                                :placeholder="$Translate('confirmPassword')" />
                        </div>

                        <div class="mt-4" style="display: flex; justify-content: center;">
                            <button type="button" class="btn w-100 custom-radius text-white"
                                style="background: #00013A;" @click.prevent="reset()">
                                {{ $Translate('resetPassword') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>

    <!-- Forget Password Successfully Modal -->
    <div class="modal fade" id="forgetSuccessModal" tabindex="-1" aria-labelledby="regSuccessModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-success-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="success-icon mb-4">
                        <img :src="gifSource" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('forgetSuccessMessageTitle') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('forgetSuccessMessageBody') }}</p>

                    <div class="d-flex justify-content-center">
                        <button type="button" class="btn btn-primary px-4 py-2 rounded-3" data-bs-dismiss="modal">
                            {{ $Translate('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Forget Password Failed Modal -->
    <div class="modal fade" id="forgetFailedModal" tabindex="-1" aria-labelledby="regFailedModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-success-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="failed-icon mb-4">
                        <img :src="gif2Source" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('forgetFailedMessageTitle') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('forgetFailedMessageBody') }}</p>

                    <div class="d-flex justify-content-center">
                        <button type="button" class="btn btn-primary px-4 py-2 rounded-3" data-bs-dismiss="modal"
                            aria-label="Close">
                            {{ $Translate('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Success Reset Modal -->
    <div class="modal fade" id="resetSuccessModal" tabindex="-1" aria-labelledby="regSuccessModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-success-modal text-center px-4 py-3 rounded-4">

                <div class="modal-body">
                    <div class="success-icon mb-4">
                        <img :src="gifSource" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('resetSuccessMessageTitle') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('resetSuccessMessageBody') }}</p>

                    <div class="d-flex justify-content-center">
                        <button type="button" class="btn btn-primary px-4 py-2 rounded-3" data-bs-dismiss="modal"
                            @click="Restart">
                            {{ $Translate('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Failed Reset Modal -->
    <div class="modal fade" id="resetFailedModal" tabindex="-1" aria-labelledby="regSuccessModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-success-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="success-icon mb-4">
                        <img :src="gif2Source" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('resetFailedMessageTitle') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('resetFailedMessageBody') }}</p>

                    <div class="d-flex justify-content-center">
                        <button type="button" class="btn btn-primary px-4 py-2 rounded-3" data-bs-dismiss="modal">
                            {{ $Translate('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
let forgetSuccessModal = null;
let forgetFailedModal = null;
let resetSuccessModal = null;
let resetFailedModal = null;
import { Modal } from 'bootstrap';

export default {
    name: 'LoginPage',
    data() {
        return {
            passwordReveal: false,
            currentModal: 'login',
            previousModal: null,
            modalOrder: ['login', 'forget', 'reset'],
            token: GetToken(),
            companyId: 'usmf',
            isRtl: document.documentElement.dir === 'rtl',

            applicant: {
                userId: '',
                password: '',
                applicantId: GetApplicantId(),
            },
            loginEmailIsValid: false,
            loginPassIsValid: false,
            loginSubmitted: false,

            gifSource: require('../../../assets/animations/success.gif'),
            gif2Source: require('../../../assets/animations/warning.gif'),

            // Forgot Modal
            forgotEmail: '',
            forgetEmailIsValid: false,
            forgetSubmitted: false,

            // Reset Modal
            newPassword: '',
            confirmNewPassword: '',
            resetToken: '',
            resetSubmitted: false,
            resetTokenIsValid: false,
            resetNewPasswordIsValid: false,
            resetConfirmNewPasswordIsValid: false,
        };
    },
    methods: {
        showModal(modalName) {
            this.previousModal = this.currentModal;

            this.animateStep(false);

            setTimeout(() => {
                this.currentModal = modalName;
                this.animateStep(true); 
            }, 300);
        },
        ApplicantLogin: async function () {
            try {
                const result = await ApplicantLogin(
                    this.companyId,
                    this.applicant.userId,
                    this.applicant.password
                );
                SetToken(result.token);
                SetApplicantId(result.applicantId);
                //console.log('token: ' + result.token)
                //console.log('applicantId: ' + result.applicantId);
                this.$router.push('/ApplicantProfile');
            } catch (error) {
                console.error("Validation failed:", error);
            }
            this.loginSubmitted = false;
        },
        signIn() {
            this.loginSubmitted = true;
            let valid = true;

            // Login Email
            if (!this.applicant.userId) {
                toastr.error(this.$Translate('emailRequired'));
                this.loginEmailIsValid = false;
                valid = false;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.applicant.userId)) {
                toastr.warning(this.$Translate('invalidEmail'));
                this.loginEmailIsValid = false;
                valid = false;
            } else {
                this.loginEmailIsValid = true;
            }

            // Login Password
            if (!this.applicant.password) {
                toastr.error(this.$Translate('passwordRequired'));
                this.loginPassIsValid = false;
                valid = false;
            } else if (this.applicant.password.length < 8) {
                toastr.warning(this.$Translate('passwordTooShort'));
                this.loginPassIsValid = false;
                valid = false;
            } else if (!/[A-Z]/.test(this.applicant.password)) {
                toastr.warning(this.$Translate('passwordUppercaseRequired'));
                this.loginPassIsValid = false;
                valid = false;
            } else if (!/[0-9]/.test(this.applicant.password)) {
                toastr.warning(this.$Translate('passwordNumberRequired'));
                this.loginPassIsValid = false;
                valid = false;
            } else {
                this.loginPassIsValid = true;
            }

            if (valid) {
                this.ApplicantLogin();
                document.getElementById("LoginForm").reset();
            }
        },
        ForgotPassword: async function () {
            try {
                const result = await ForgotPassword(
                    this.companyId,
                    this.forgotEmail,
                );
                //console.log("API Response:", result);

                if (result?.status === 200 && result.data?.success !== false) {
                    forgetSuccessModal.show();

                    this.showModal('reset', 'next');
                } else {
                    forgetFailedModal.show();
                }
            } catch (error) {
                console.error("Validation failed:", error);
                forgetFailedModal.show();
            }
            this.forgetSubmitted = false;
        },
        forgot() {
            this.forgetSubmitted = true;
            let valid = true;

            // Forgot Email
            if (!this.forgotEmail) {
                toastr.error(this.$Translate('emailRequired'));
                this.forgetEmailIsValid = false;
                valid = false;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.forgotEmail)) {
                toastr.warning(this.$Translate('invalidEmail'));
                this.forgetEmailIsValid = false;
                valid = false;
            } else {
                this.forgetEmailIsValid = true;
            }

            if (valid) {
                this.ForgotPassword();
                this.forgotEmail = '';
            }
        },
        ResetPassword: async function () {
            try {
                const result = await ResetPassword(
                    this.companyId,
                    this.forgotEmail,
                    this.newPassword,
                    this.confirmNewPassword,
                    this.resetToken,
                );
                if (result?.status === 200 && result.data?.success !== false) {
                    resetSuccessModal.show();
                } else {
                    resetFailedModal.show();
                }
            } catch (error) {
                console.error("Validation failed:", error);
                resetFailedModal.show();
            }
            this.forgotEmail = '';
            this.newPassword = '';
            this.confirmNewPassword = '';
            this.resetToken = ''
            this.resetSubmitted = false;
        },
        reset() {
            this.resetSubmitted = true;
            let valid = true;

            // Token (OTP)
            if (!this.resetToken) {
                toastr.error(this.$Translate('tokenRequired'));
                this.resetTokenIsValid = false;
                valid = false;
            } else {
                this.resetTokenIsValid = true;
            }

            // Reset New Password
            if (!this.newPassword) {
                toastr.error(this.$Translate('passwordRequired'));
                this.resetNewPasswordIsValid = false;
                valid = false;
            } else if (this.newPassword.length < 8) {
                toastr.warning(this.$Translate('passwordTooShort'));
                this.resetNewPasswordIsValid = false;
                valid = false;
            } else if (!/[A-Z]/.test(this.newPassword)) {
                toastr.warning(this.$Translate('passwordUppercaseRequired'));
                this.resetNewPasswordIsValid = false;
                valid = false;
            } else if (!/[0-9]/.test(this.newPassword)) {
                toastr.warning(this.$Translate('passwordNumberRequired'));
                this.resetNewPasswordIsValid = false;
                valid = false;
            } else {
                this.resetNewPasswordIsValid = true;
            }

            // Reset Confirm New Password
            if (!this.confirmNewPassword || this.confirmNewPassword.trim() === '') {
                toastr.error(this.$Translate('confirmEmailRequired'));
                this.resetConfirmNewPasswordIsValid = false;
                valid = false;
            } else if (this.confirmNewPassword !== this.newPassword) {
                toastr.warning(this.$Translate('confirmEmailMismatch'));
                this.resetConfirmNewPasswordIsValid = false;
                valid = false;
            } else {
                this.resetConfirmNewPasswordIsValid = true;
            }

            if (valid) {
                this.ResetPassword();
                document.getElementById("ResetPasswordForm").reset();
            }
        },
        Restart() {
            window.location.reload();
        },
        animateStep(isIn = false) {
            const modal = this.$refs.modalContainer;
            if (!modal) return;

            modal.classList.remove('bounce-in', 'bounce-out');

            if (isIn) {
                modal.classList.add('bounce-in');
            } else {
                modal.classList.add('bounce-out');
            }
        },
    },
    mounted() {
        this.currentModal = 'login';

        forgetSuccessModal = new Modal(document.getElementById("forgetSuccessModal"), {});
        forgetFailedModal = new Modal(document.getElementById("forgetFailedModal"), {});
        resetSuccessModal = new Modal(document.getElementById("resetSuccessModal"), {});
        resetFailedModal = new Modal(document.getElementById("resetFailedModal"), {});
    },
    computed: {
        modalTransitionClasses() {
            const prevIndex = this.modalOrder.indexOf(this.previousModal);
            const currIndex = this.modalOrder.indexOf(this.currentModal);

            if (prevIndex < currIndex) {
                // Going forward
                return {
                    enter: 'animate__animated animate__fadeInRightBig animate__faster',
                    leave: 'animate__animated animate__fadeOutLeftBig animate__faster'
                };
            } else if (prevIndex > currIndex) {
                // Going backward
                return {
                    enter: 'animate__animated animate__fadeInLeftBig animate__faster',
                    leave: 'animate__animated animate__fadeOutRightBig animate__faster'
                };
            }
        }
    }
};
</script>

<style scoped>
/* You can add custom styles for this component here */
.mainContainer {
    height: 100vh;
    background-image: url('../../../../dist/assets/login-bg.png');
    background-size: cover;
    background-position: center;
}

.mainContainer .logo img {
    position: absolute;
    top: 20px;
    left: 25px;
    font-size: 24px;
    font-weight: bold;
}

.loginModal,
.forgetModal,
.resetModal {
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    min-height: 500px;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
}

.eye-icon {
    position: absolute;
    top: 73%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #6c757d;
}

html[dir="ltr"] .eye-icon {
    right: 20px;
}

html[dir="rtl"] .eye-icon {
    left: 20px;
    transform: translateY(-50%) scaleX(-1);
    /* flip the icon */
}

.language-switcher {
    display: flex;
    gap: 6px;
    background: #f0f0f0;
    padding: 4px;
    border-radius: 30px;
    align-items: center;
}

.lang-btn {
    background: transparent;
    border: none;
    padding: 6px 14px;
    font-size: 14px;
    font-weight: 600;
    color: #555;
    border-radius: 20px;
    transition: background-color 0.2s, color 0.2s;
    cursor: pointer;
}

.lang-btn.active {
    background-color: #00013A;
    color: white;
    pointer-events: none;
}

.lang-btn:hover {
    background-color: #FFD1A4;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

@keyframes bounceIn {
    0% {
        opacity: 0;
        transform: scale(0.3);
    }

    50% {
        opacity: 1;
        transform: scale(1.05);
    }

    70% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes bounceOut {
    0% {
        opacity: 1;
        transform: scale(1);
    }

    20% {
        transform: scale(0.9);
    }

    50% {
        opacity: 0;
        transform: scale(1.2);
    }

    100% {
        opacity: 0;
        transform: scale(0);
    }
}

.bounce-in {
    animation: bounceIn 0.6s ease forwards;
}

.bounce-out {
    animation: bounceOut 0.6s ease forwards;
}
</style>
